import React from "react";
import { CreateExperiencePurchaseSidebar } from "./CreateExperiencePurchaseSidebar";
import { CreatePackagePurchaseSidebar } from "./CreatePackagePurchaseSidebar";
import { PurchaseManager } from "./PurchaseManager";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const CreatePurchaseSidebar = React.memo(() => {
    const isPackageProduct = useCreatePurchaseStore((state) => !!state.getPurchasePackageId());

    return (
        <>
            {isPackageProduct ? <CreatePackagePurchaseSidebar /> : <CreateExperiencePurchaseSidebar />}
            <PurchaseManager />
        </>
    );
});

CreatePurchaseSidebar.displayName = "CreatePurchaseSidebar";
